const messages = {
  en: {
    title: 'GET MORE HELP',
    body: "Have a question and can't find the answer in the Knowledge Base?",
    contact: 'Contact Us'
  },
  'es-ud': {
    title: 'OBTENGA MÁS AYUDA',
    body:
      '¿Tiene una pregunta y no encuentra la respuesta en la Base de Conocimientos?',
    contact: 'Contáctenos'
  },
  es: {
    title: 'OBTÉN MÁS AYUDA',
    body:
      '¿Tienes una pregunta y no encuentras la respuesta en la Base de Conocimientos?',
    contact: 'Contáctanos'
  }
}

export default messages



// WEBPACK FOOTER //
// ./src/components/MoreHelpFooter/messages.js